<app-clients-bar [origin]="origin"></app-clients-bar>